import { Component } from '@angular/core';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-integracao-zoppy-saiba-mais-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './integracao-zoppy-saiba-mais-dialog.component.html',
  styleUrls: ['./integracao-zoppy-saiba-mais-dialog.component.css'],
})
export class IntegracaoZoppySaibaMaisDialogComponent {
  constructor(public dialogRef: MatDialogRef<IntegracaoZoppySaibaMaisDialogComponent>) {}

  fechar(): void {
    this.dialogRef.close();
  }
}
